export default __webpack_public_path__ + "static/media/menu-burger-white.95a1e86e.svg";